var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex px-4 py-3 space-x-2 border rounded-md"},[(_vm.icon)?_c('FontAwesomeIcon',{staticClass:"mt-1",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex-auto font-medium"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }